import GrowVerticalIcon from '@atlaskit/icon/core/grow-vertical';
import React from 'react';

export const SvgExpandReplies = () => (
  <GrowVerticalIcon label="" testId="ads-refreshed-icon" />
);
